import { render, staticRenderFns } from "./MainDashboard.vue?vue&type=template&id=5b269e4a&scoped=true"
import script from "./MainDashboard.vue?vue&type=script&lang=ts"
export * from "./MainDashboard.vue?vue&type=script&lang=ts"
import style0 from "./MainDashboard.vue?vue&type=style&index=0&id=5b269e4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b269e4a",
  null
  
)

export default component.exports